import React, { useContext } from "react";
import { Link } from "react-router-dom";
import Section from "../Section";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Badge from "react-bootstrap/Badge";
import ButtonMarketing from "../ButtonMarketing";
import { CookieContext } from "../../contexts/CookieContext";
import Matomo from "../../utilities/Matomo";
import ButtonLink from "../ButtonLink";

const ShopPromotion = () => {
  const [cookies] = useContext(CookieContext);
  const handleShopLinkClick = () => {
    if (cookies.performance) {
      Matomo.push(["trackGoal", 4]);
    }
  };
  return (
    <Section variant="primary">
      <Container>
        <Row className="d-flex justify-content-center">
          <Col md={8} lg={6} xl={5} className="text-center">
            <Row className="text-center">
              <Col>
                <Badge variant="light" className="mb-1">
                  Shop
                </Badge>
                <h2>Lernmaterialien</h2>
                <p className="lead">
                  Effektiv lernen mit digitalen Materialien vom Dozenten!
                </p>
              </Col>
            </Row>
            <Row className="mt-4 mb-4">
              <Col>
                Sie studieren VWL, BWL, Rechnungswesen oder Controlling? In
                meinem Patreon-Shop finden Sie hochwertige Lernmaterialien – von
                verständlichen Skripten über prüfungsnahe Aufgaben bis hin zu
                kompakten Stichwortkarten. Ob für die Klausurvorbereitung oder
                zur Vertiefung –{" "}
                <strong>alles aus einer Hand, direkt vom Dozenten</strong>.
                <br />
                <br />
                Jetzt entdecken und durchstarten:
              </Col>
            </Row>
            <Row className="mt-2">
              <Col className="d-flex justify-content-center">
                <ButtonLink
                  className="mr-3 text-light"
                  as={Link}
                  to="/produkte"
                >
                  Alle Produkte
                </ButtonLink>
                <ButtonMarketing
                  as={Link}
                  to="//www.patreon.com/JohannesVolk/shop"
                  target="_blank"
                  onClick={handleShopLinkClick}
                >
                  Zum Shop
                </ButtonMarketing>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </Section>
  );
};

export default ShopPromotion;
